<template>
  <div class="message-card">
    <p class="Title3">{{ message.channelname }}</p>
    <p class="Body3 gray-400 m-t-5">Started: {{ formattedStartDate }}</p>
    <p class="Label1 gray-400 m-t-5"
       v-if="showDuration">
      Duration: {{ formattedDuration }}
    </p>

    <div class="files-shared">
      <p class="Label1 gray-200 m-t-5"
         v-if="!hasFiles">No files shared.</p>
      <div class="container m-t-5"
           v-if="hasFiles">
        <div class="replies"
             v-if="hasReplies">
          <p><span :class="'ns-icon-speech-bubble'"/> {{ noOfReplies }} replies</p>
        </div>
        <div class="files">
          <p><span :class="'ns-icon-attachment'"/> {{ messageStats.files }} files</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import {convertDuration} from '@/utils/dates';

  export default {
    name: "MessageSession",
    props: {
      message: {type: Object, required: false},
    },
    computed: {
      formattedStartDate() {
        return moment(this.message.start_date).format('dddd, MMMM Do YYYY, h:mm A');
      },
      formattedDuration() {
        return convertDuration(this.message.session_duration);
      },
      messageStats() {
        return this.message.messagestats;
      },
      hasFiles() {
        return this.message.messagestats.files !== 0;
      },
      hasReplies() {
        return this.noOfReplies > 0;
      },
      noOfReplies() {
        return this.messageStats.total - this.messageStats.files;
      },
      showDuration() {
        return this.message.session_duration > 1000;
      }
    }
  }
</script>

<style lang="scss">
  .message-card {
    @include box-shadow($shadow);
    position: relative;
    border-radius: radius(medium);
    padding: space(m);

    .files-shared {
      .container {
        display: flex;
        flex-direction: row;
        color: color(dodgerBlue);
        font-size: 12px;
        font-weight: 700;
      }

      .replies {
        @include space-me($prop: margin, $r: s);
      }

      span {
        @include space-me($prop: margin, $r: xs);
      }
    }
  }
</style>